import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** First letter of each word upper, rest lower (e.g. "LUIS ALBERTO CAL" → "Luis Alberto Cal"). */
export function toTitleCase(s: string | null | undefined): string {
  if (s == null || s.trim() === "") return "";
  return s
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
